import React from "react";
import { createPortal } from "react-dom";

function QPortal({ children }) {
    return createPortal(children, document.body);
}

export default QPortal;
